import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="text-center">
          <Col md={6}>
            <p>© {new Date().getFullYear()} Pohlert Steinreinigung</p>
          </Col>
          <Col md={6}>
            <p>
              <a href="/impressum">Impressum</a> | <a href="/datenschutz">Datenschutz</a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
